module.exports = __webpack_public_path__ + "assets/img/site-03.359d56c6.jpg";